import { render, staticRenderFns } from "./RatingsComp.vue?vue&type=template&id=79cc37e8&"
import script from "./RatingsComp.vue?vue&type=script&lang=js&"
export * from "./RatingsComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports